export default __webpack_public_path__ + "static/media/SearchingCard.897d32a5.png";